/**
 * Safe string conversion for unknown values.
 * Avoids Object's default '[object Object]' stringification (Sonar S6551).
 */
export function unknownToString(value: unknown): string {
  if (value == null) return '';
  switch (typeof value) {
    case 'string':
      return value;
    case 'number':
    case 'boolean':
    case 'bigint':
    case 'symbol':
      return String(value);
    case 'object':
      try {
        return JSON.stringify(value) ?? '';
      } catch {
        return Object.prototype.toString.call(value);
      }
    default:
      return '';
  }
}

/**
 * Extracts a JSON Schema / OpenAPI type name that may be a string,
 * string[], or nested object — never stringifies objects.
 */
export function schemaTypeToString(type: unknown, fallback = 'string'): string {
  if (typeof type === 'string') return type;
  if (Array.isArray(type)) {
    const primary = type.find(
      (entry): entry is string =>
        typeof entry === 'string' && entry.toLowerCase() !== 'null'
    );
    return primary ?? fallback;
  }
  return fallback;
}
